module.exports = (__webpack_require__(1))(45);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/CollectionModel.js from dll-reference girder_lib
// module id = 13
// module chunks = 0